import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [currPath, setCurrPath] = useState("");
  const [prevPath, setPrevPath] = useState("");

  useEffect(() => {
    // don't scroll to top if going back, unless it's editing an event
    if (prevPath !== pathname || (pathname.includes('edit_event') || currPath.includes('edit_event'))) {
      console.log("see mee");
      window.scrollTo(0, 0);
    }
    setPrevPath(currPath);
    setCurrPath(pathname);
  }, [pathname]);

  return null;
}
